var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtonNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 40,
    viewBox: "0 0 56 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 39,
    rx: 19.5,
    stroke: "#303F47"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20598_618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.85 11.85L33.3 13.3L31.12 15.46C30.73 15.85 30.73 16.49 31.12 16.88C31.51 17.27 32.15 17.27 32.54 16.88L34.7 14.7L36.15 16.15C36.46 16.46 37 16.24 37 15.79V11.5C37 11.22 36.78 11 36.5 11L32.21 11C31.76 11 31.54 11.54 31.85 11.85ZM19.85 16.15L21.3 14.7L23.46 16.88C23.85 17.27 24.49 17.27 24.88 16.88C25.27 16.49 25.27 15.85 24.88 15.46L22.7 13.3L24.15 11.85C24.46 11.54 24.24 11 23.79 11H19.5C19.22 11 19 11.22 19 11.5V15.79C19 16.24 19.54 16.46 19.85 16.15ZM24.15 28.15L22.7 26.7L24.88 24.54C25.27 24.15 25.27 23.51 24.88 23.12C24.49 22.73 23.85 22.73 23.46 23.12L21.3 25.3L19.85 23.85C19.54 23.54 19 23.76 19 24.21V28.5C19 28.78 19.22 29 19.5 29H23.79C24.24 29 24.46 28.46 24.15 28.15ZM36.15 23.85L34.7 25.3L32.54 23.12C32.15 22.73 31.51 22.73 31.12 23.12C30.73 23.51 30.73 24.15 31.12 24.54L33.3 26.7L31.85 28.15C31.54 28.46 31.76 29 32.21 29H36.5C36.78 29 37 28.78 37 28.5V24.21C37 23.76 36.46 23.54 36.15 23.85Z",
    fill: "#303F47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20598_618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonNew);
export default __webpack_public_path__ + "static/media/_button_new.76b0ebcacffb8972f776a899bb397724.svg";
export { ForwardRef as ReactComponent };